export interface ILogMessage {
    source: string;
    message: string;
    level: LogLevel;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: any;
}

export enum LogLevel {
    None = 'None',
    Verbose = 'Verbose',
    Info = 'Info',
    Warn = 'Warn',
    Error = 'Error'
}
